module.exports = __webpack_public_path__ + "static/images/callout_3.3b3352b3e58d19570eb72e9a4fd3ff7a.jpg";